import styled from "@emotion/styled";

export const StyledDrawerContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const StyledDrawerHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;

  @media (min-width: 760px) {
    gap: 24px;
    padding: 48px 40px 40px 40px;
  }
`;

export const StyledProfileRecap = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (min-width: 760px) {
    gap: 24px;
  }
`;

export const StyledProfileAvatarContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  width: 64px;

  @media (min-width: 760px) {
    height: 86px;
    width: 86px;
  }
`;

export const StyledProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 760px) {
    gap: 12px;
  }
`;

export const StyledDrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;

  @media (min-width: 760px) {
    gap: 42px;
    padding: 32px;
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 760px) {
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  }
`;
